import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'

// Layouts & Widgets
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import GranteePropertyWidgets from '../../../widgets/projectProposal/granteeProperty/GranteePropertyWidgets'
import AttachFilesGranteeContract from '../../../widgets/makeContract/AttachFilesGranteeContract'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'

import '../styles.less'
// Components & Buttons
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ViewPreviousVersionButon from '../../../components/buttons/viewPreviousVersionButon/ViewPreviousVersionButon'

// Utils & Actions
import { startLoading, doneLoading } from '../../../utils/loading'
import {
  getGranteeProperty,
  downloadGranteeFileById,
  getGranteeAllFile,
  deleteGranteeFileById,
} from '../../../redux/actions/granteeProperty'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'

// Constants
import pathname from '../../../constants/pathname'
import { ERR_MSG_404_PROJECT_ID } from '../../../constants/msgText'

// Styles
import '../styles.less'

export default function GranteeProperty() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [schemaPrevious, setSchemaPrevious] = useState()
  const [isViewPrevious, setIsViewPrevious] = useState(false)

  // Error States สำหรับ Widget
  const [isEditErr, setIsEditErr] = useState(false)
  const [isUploadErr, setIsUploadErr] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isGranteeFileError, setIsGranteeFileError] = useState(false)

  const projectId = sessionStorage.getItem('projectId')
  const buttonRoute = {
    pathNameBackward: `${pathname.proposal.attachFiles}`,
    pathNameForward: `${pathname.proposal.responsibleManBasicInfo}`,
  }

  useEffect(() => {
    if (projectId) handleGetSchema(projectId)
    else setError({ statusCode: 404, errorMessage: ERR_MSG_404_PROJECT_ID })
  }, [])

  const handleGetSchema = async (id) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getGranteeProperty(id)
      setSchema(_schema)
      setIsEditWidget({ property: _schema.forms?.property?.id ? false : true })
    } catch (e) {
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetSchemaPrevious = async (id) => {
    setIsLoading(true)
    startLoading()
    try {
      if (isViewPrevious) {
        setIsViewPrevious(false)
        doneLoading()
        setIsLoading(false)
        return
      }
      if (schemaPrevious) {
        setIsViewPrevious(true)
        doneLoading()
        setIsLoading(false)
        return
      }
      const _schema = await getGranteeProperty(id)
      setSchemaPrevious(_schema)
      setIsViewPrevious(true)
    } catch (e) {
      console.error('e', e)
    }
    doneLoading()
    setIsLoading(false)
  }

  const onDownload = async (fileObj) => {
    startLoading()
    try {
      var file = await downloadGranteeFileById(projectId, fileObj.id)
      const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileObj.name)
      document.body.appendChild(link)
      link.click()
      setIsGranteeFileError()
    } catch (e) {
      setIsGranteeFileError('ดาวน์โหลดไม่สำเร็จ')
    }
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    try {
      var file = await downloadGranteeFileById(projectId, fileObj.id)
      const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
      const link = document.createElement('a')
      link.href = url
      link.target = '_blank'
      link.setAttribute('value', fileObj.name)
      document.body.appendChild(link)
      link.click()
      setIsGranteeFileError()
    } catch (e) {
      setIsGranteeFileError('แสดงไม่สำเร็จ')
    }
    doneLoading()
  }

  const handleDelete = async (id) => {
    startLoading()
    setIsDeleteError(false)
    try {
      const status = await deleteGranteeFileById(projectId, id)
      if (status === 200) {
        let response = await getGranteeAllFile(projectId)
        setSchema((state) => ({
          ...state,
          forms: { ...state.forms, property: { ...state.forms.property, attachFiles: response } },
        }))
      } else {
        setIsDeleteError('ไม่สำเร็จ')
      }
    } catch (e) {
      setIsDeleteError(e?.response?.data?.errorMessage || 'ไม่สำเร็จ')
    }
    doneLoading()
  }

  const handleOnUploadSuccess = (res) => {
    setSchema((state) => ({
      ...state,
      forms: { ...state.forms, property: { ...state.forms.property, attachFiles: res } },
    }))
  }

  if (error)
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )

  if (!schema || isLoading)
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )

  const renderPropertyVersion = ({
    currentSchema,
    isEdit,
    showCommandButton,
    disabledForm,
    onChangeIsEdit,
    onUploadSuccess,
    onDelete,
    onDownload,
    onPreview,
    isEditErrState,
    isUploadErrState,
    isDeleteErrorState,
    loadingState,
  }) => (
    <div className="top proposal-grantee-property-content-wrap" style={{ width: '100%' }}>
      {currentSchema?.forms?.property?.attachFiles && (
        <Panel
          className="proposal-grantee-attach-files-panel"
          shaded
          header={
            <b style={{ fontSize: '16px' }}>{currentSchema?.forms?.property?.attachFiles.header}</b>
          }
          defaultExpanded
          collapsible
          style={{ width: '100%', marginBottom: '20px' }}
        >
          <div style={{ padding: '0 0 10px 0', width: '100%' }}>
            <AttachFilesGranteeContract
              schema={currentSchema.forms.property}
              onDelete={onDelete}
              onDownload={onDownload}
              onPreview={onPreview}
              onUploadSuccess={onUploadSuccess}
              isEditErr={isEditErrState}
              isUploadErr={isUploadErrState}
              isDeleteError={isDeleteErrorState}
              loading={loadingState}
              disabledForm={disabledForm}
            />
          </div>
        </Panel>
      )}

      {currentSchema?.forms?.property && (
        <GranteePropertyWidgets
          showCommandButton={showCommandButton}
          isEdit={isEdit}
          onChangeIsEdit={onChangeIsEdit}
          formSchema={currentSchema}
        />
      )}
    </div>
  )

  return (
    <SidebarProposal>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      <ViewPreviousVersionButon
        handleGetSchemaPrevious={handleGetSchemaPrevious}
        isViewPrevious={isViewPrevious}
      />

      {!schema.forms?.property?.disabled && (
        <BtnEditAll
          onClickEditAll={getIsEditAll(isEditWidget)}
          routing={buttonRoute}
          setOnClickEditAll={(_isEdit) => setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)}
          editWidget={isEditWidget}
          forms={schema?.forms}
        />
      )}

      {/* 🚩 ใช้ wrapper จาก styles.less เพื่อรองรับ Side-by-Side เปรียบเทียบเวอร์ชัน */}
      <div
        className="wrapper proposal-grantee-property-page"
        style={{ display: 'block', width: '100%' }}
      >
        {/* คอลัมน์ที่ 1: เวอร์ชันปัจจุบัน */}
        <div style={{ width: '100%', minWidth: 0 }}>
          {isViewPrevious ? (
            <Panel
              collapsible
              defaultExpanded
              shaded
              bordered
              header={'version ปัจจุบัน'}
              style={{ maxHeight: '700px', overflowY: 'auto' }}
            >
              <div style={{ padding: '0', width: '100%' }}>
                {renderPropertyVersion({
                  currentSchema: schema,
                  isEdit: isEditWidget.property,
                  showCommandButton: !schema.forms.property.disabled,
                  disabledForm: schema.forms.property.disabled,
                  onChangeIsEdit: (_isEdit) =>
                    handleOnChangeIsEdit('property', _isEdit, setIsEditWidget),
                  onUploadSuccess: handleOnUploadSuccess,
                  onDelete: handleDelete,
                  onDownload,
                  onPreview,
                  isEditErrState: isEditErr,
                  isUploadErrState: isUploadErr,
                  isDeleteErrorState: isDeleteError,
                  loadingState: isLoading,
                })}
              </div>
            </Panel>
          ) : (
            <div style={{ width: '100%' }}>
              {renderPropertyVersion({
                currentSchema: schema,
                isEdit: isEditWidget.property,
                showCommandButton: !schema.forms.property.disabled,
                disabledForm: schema.forms.property.disabled,
                onChangeIsEdit: (_isEdit) =>
                  handleOnChangeIsEdit('property', _isEdit, setIsEditWidget),
                onUploadSuccess: handleOnUploadSuccess,
                onDelete: handleDelete,
                onDownload,
                onPreview,
                isEditErrState: isEditErr,
                isUploadErrState: isUploadErr,
                isDeleteErrorState: isDeleteError,
                loadingState: isLoading,
              })}
            </div>
          )}
        </div>

        {/* คอลัมน์ที่ 2: เวอร์ชันก่อนหน้า (แสดงเมื่อกดเปรียบเทียบ) */}
        {isViewPrevious && schemaPrevious && (
          <div style={{ width: '100%', minWidth: 0, marginTop: '16px' }}>
            <Panel
              collapsible
              defaultExpanded
              shaded
              bordered
              header={'version ก่อนหน้า'}
              style={{
                maxHeight: '700px',
                overflowY: 'auto',
                width: '100%',
                backgroundColor: '#e4e4ed',
              }}
            >
              <div className="bottom" style={{ padding: '0', width: '100%' }}>
                {renderPropertyVersion({
                  currentSchema: schemaPrevious,
                  isEdit: false,
                  showCommandButton: false,
                  disabledForm: true,
                  onChangeIsEdit: () => {},
                  onUploadSuccess: () => {},
                  onDelete: () => {},
                  onDownload,
                  onPreview,
                  isEditErrState: false,
                  isUploadErrState: false,
                  isDeleteErrorState: false,
                  loadingState: false,
                })}
              </div>
            </Panel>
          </div>
        )}
      </div>
      <br />
      <br />
    </SidebarProposal>
  )
}
